export enum DisplayOption {
	None,
	TariffOverview,
	Options
}